module.exports = __webpack_public_path__ + "img/Availability Tracking_old.5eab6d07.svg";